import { createRootRoute, Outlet } from "@tanstack/react-router";

import { NotFoundPage } from "@/components/errors/not-found";
import { catalogue } from "@/content";
import { useLocale } from "@/context/locale-provider";

export const Route = createRootRoute({
  component: RootLayout,
  notFoundComponent: NotFoundPage,
});

function RootLayout() {
  const { locale } = useLocale();
  const skip = catalogue(locale).app.skipToContent;

  return (
    <>
      <a
        href="#main"
        className="sr-only focus:not-sr-only focus:fixed focus:start-4 focus:top-4 focus:z-[100] focus:rounded-md focus:bg-n9 focus:px-4 focus:py-2 focus:text-n0"
      >
        {skip}
      </a>
      <Outlet />
    </>
  );
}
